// Panel widths are fixed dimensions, hardcoded as rem (not from the spacing
// scale), matching the Figma modal frames: 440 (sm), 600 (md, the default
// confirm modal), 940 (lg), 1120 (xl) and 1488 (xxl) for the wide data tables.
export const ModalSize = {
  SM: 'sm',
  MD: 'md',
  LG: 'lg',
  XL: 'xl',
  XXL: 'xxl',
} as const;
export type ModalSize = (typeof ModalSize)[keyof typeof ModalSize];

export const ModalSide = {
  LEFT: 'left',
  RIGHT: 'right',
} as const;
export type ModalSide = (typeof ModalSide)[keyof typeof ModalSide];

/**
 * Colour applied to the header glyph. The glyph itself is chosen with `icon`,
 * so any pairing is possible: a trophy in success green, a plain dark warning.
 * The canonical status pairings are info-circle/INFO, check-circle/SUCCESS,
 * warning/WARNING and error-circle/ERROR.
 */
export const ModalIconColor = {
  INFO: 'info',
  SUCCESS: 'success',
  WARNING: 'warning',
  ERROR: 'error',
} as const;
export type ModalIconColor =
  (typeof ModalIconColor)[keyof typeof ModalIconColor];

export const MODAL_TRANSITION_DURATION = 200;
